import React, { useState } from "react";
import { useRouter } from "next/router";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { GiftRedeemPage } from "@ecologi/react-components/src/GiftRedeemPage";
import { User, UserType } from "@ecologi/shared";
import {
  redeemGift,
  getGiftingCouponCode,
  formatAPIErrorForView,
  APIError,
} from "../../../lib";
import { Head } from "../../../components";
import { useStore } from "../../../store";
import { openChatWidget } from "../../../lib/hubspot";

async function prefetchData() {
  return {
    props: {
      layoutProps: {
        isLightHeader: true,
        isWhiteBody: true,
      },
    },
  };
}

export function GiftingRedeemPage() {
  const { location, setUser } = useStore();
  const router = useRouter();
  const [couponCode, setCouponCode] = useState<string | undefined>();
  const locationWithDefault = location || { countryCode: "GB" };

  const [redeemGiftMutation] = useMutation<
    { user: UserType; planId: string },
    APIError
  >(redeemGift, {
    onError: (error) => {
      toast.error(formatAPIErrorForView(error));
    },
    onSuccess: ({ user }) => {
      setUser(new User(user));
      router.push("/thanks");
    },
  });

  const result = useQuery(
    ["gifting-coupon-code", couponCode],
    getGiftingCouponCode,
    {
      enabled: !!couponCode,
      retry: false,
      refetchOnWindowFocus: false,
      onError: (error: APIError) => {
        toast.error(formatAPIErrorForView(error));
      },
    }
  );

  return (
    <>
      <Head
        title="Redeem"
        socialTitle="Redeem your gift and help the planet :earth_americas:"
        description="Redeem your Climate Positive gift with Ecologi. Your zero-waste present will plant trees and support climate action today."
        imageUrl="/images/app/gifting/gifting_social_share_christmas.png"
      />
      <GiftRedeemPage
        location={locationWithDefault}
        onSubmitRedeemGift={redeemGiftMutation}
        couponCodeRecord={result.data}
        onSubmitCouponCode={async (couponCode: string) => {
          setCouponCode(couponCode);
        }}
        openChatWidget={() => openChatWidget(router)}
      />
    </>
  );
}

GiftingRedeemPage.prefetchData = prefetchData;
